<template>

    <fragment>
        <a href="#" :title="language.comment_on" class="action add-on-existing" v-on:click.prevent="showExistingWindow">{{ language.comment_on }}</a>
    </fragment>

</template>

<script>

import { markerObject, addAnswer, toggleOpinionForm } from './../../functions'
import { Fragment } from 'vue-fragment'
import dataStore from "../../store"

export default {

    inject: [ 'language' ],

    components: {
        Fragment
    },

    data() {
        return {
            dataStore,
            opinion : null
        };
    },

    mounted() {
        this.opinion = null
    },

    props: {
        marker : Object,
        slide: Object,
        project: Object,
    },

    methods : {

        showExistingWindow: function() {
            this.addMarker()
        },

        addMarker: function() {
            
            this.dataStore.formPopUpReady = true;
            
            this.dataStore.addToExistingWindow = true;
            
            this.dataStore.collectedAnswers = this.dataStore.collectedAnswers.filter(a => !a.addOnExisting);
            // gets item/slide
            this.opinion = markerObject(parseFloat(this.marker.lat), parseFloat(this.marker.lng), this.marker.item_id, this.marker.question);
            
            this.opinion.addOnExisting = true;

            this.opinion.created = true

            this.dataStore.currentOpinion = this.opinion
            //opens popupform
            toggleOpinionForm(this.dataStore.currentOpinion);
            //adds marker to collection
            addAnswer(this.dataStore.currentOpinion);

            this.$emit('close-popup')
        }

    }
};
</script>

